export const GET_REGIONS = "GET_REGIONS";
export const GET_WALMART_REGIONS = "GET_WALMART_REGIONS";
export const GET_WALMART_REGIONS_For_Grid = "GET_WALMART_REGIONS_For_Grid";
export const GET_FUNCTIONS = "GET_FUNCTIONS";
export const GET_FUNCTIONS_ALL = "GET_FUNCTIONS_ALL";
export const GET_FUNCTION_MASTERDATA = "GET_FUNCTION_MASTERDATA";
export const GET_FUNCTION_DETAILS_BY_ID = "GET_FUNCTION_DETAILS_BY_ID";
export const GET_FUNCTIONS_ALL_For_LogSummary =
  "GET_FUNCTIONS_ALL_For_LogSummary";
export const GET_EMAIL_ORDER_REGIONS = "GET_EMAIL_ORDER_REGIONS";
